// 企微管理 —— 中文 i18n
// 命名空间: app.wecom.*

export const zhCN_wecom = {
	// 页面标题
	'app.wecom.activeCode.title': '企微活码',
	'app.wecom.colleague.title': '企微同事',
	'app.wecom.group.title': '企微群聊',
	'app.wecom.customer.title': '企微客户',

	// 通用占位说明(同事/群聊/客户页使用)
	'app.wecom.placeholder': '该页面即将开放,功能建设中。',

	// ===== 活码页 =====

	// 搜索区
	'app.wecom.activeCode.search.name': '活码名称',
	'app.wecom.activeCode.search.name.placeholder': '请输入',
	'app.wecom.activeCode.search.scope': '使用范围',
	'app.wecom.activeCode.search.scope.placeholder': '请选择',
	'app.wecom.activeCode.search.creator': '创建人',
	'app.wecom.activeCode.search.creator.placeholder': '请选择',
	'app.wecom.activeCode.search.status': '状态',
	'app.wecom.activeCode.search.status.placeholder': '请选择',
	'app.wecom.activeCode.search.createTime': '创建时间',
	'app.wecom.activeCode.search.createTime.range': '请选择日期范围',

	// 状态枚举
	'app.wecom.activeCode.status.active': '使用中',
	'app.wecom.activeCode.status.disabled': '已停用',

	// 表格列
	'app.wecom.activeCode.table.name': '活码名称',
	'app.wecom.activeCode.table.scope': '使用范围',
	'app.wecom.activeCode.table.owner': '扫码用户',
	'app.wecom.activeCode.table.customerCount': '添加客户数',
	'app.wecom.activeCode.table.tags': '标签',
	'app.wecom.activeCode.table.creator': '创建人',
	'app.wecom.activeCode.table.createTime': '创建时间',

	// 操作按钮
	'app.wecom.activeCode.button.create': '新建活码',
	'app.wecom.activeCode.button.export': '导出',
	'app.wecom.activeCode.button.download': '下载',
	'app.wecom.activeCode.button.addRecord': '添加记录',

	// 详情 Modal
	'app.wecom.activeCode.detail.title': '活码详情',
	'app.wecom.activeCode.detail.name': '活码名称',
	'app.wecom.activeCode.detail.url': '二维码链接',
	'app.wecom.activeCode.detail.scope': '使用范围',
	'app.wecom.activeCode.detail.owner': '扫码用户',
	'app.wecom.activeCode.detail.customerCount': '添加客户数',
	'app.wecom.activeCode.detail.tags': '关联标签',
	'app.wecom.activeCode.detail.creator': '创建人',
	'app.wecom.activeCode.detail.createTime': '创建时间',
	'app.wecom.activeCode.detail.status': '状态',

	// 添加记录 Drawer
	'app.wecom.activeCode.addRecord.title': '添加记录',
	'app.wecom.activeCode.addRecord.target': '活码',
	'app.wecom.activeCode.addRecord.column.customer': '客户名',
	'app.wecom.activeCode.addRecord.column.addTime': '添加时间',
	'app.wecom.activeCode.addRecord.column.tags': '标签',
	'app.wecom.activeCode.addRecord.empty': '暂无添加记录',

	// 空态
	'app.wecom.activeCode.empty': '暂无活码,点击右上角"新建活码"创建',

	// ===== 同事页 =====
	'app.wecom.colleague.search.placeholder': '组名/姓名/电话/搜索',
	'app.wecom.colleague.title.suffix': '({count}人)',
	'app.wecom.colleague.table.name': '姓名',
	'app.wecom.colleague.table.department': '部门',
	'app.wecom.colleague.table.phone': '电话',
	'app.wecom.colleague.table.email': '邮箱',
	'app.wecom.colleague.empty': '该部门暂无同事',

	// ===== 群聊页(客户群)=====

	// 搜索区
	'app.wecom.group.search.name': '群名',
	'app.wecom.group.search.name.placeholder': '请输入',
	'app.wecom.group.search.owner': '群主',
	'app.wecom.group.search.owner.placeholder': '请选择',
	'app.wecom.group.search.member': '群成员',
	'app.wecom.group.search.member.placeholder': '请选择',
	'app.wecom.group.search.createTime': '创建时间',
	'app.wecom.group.search.createTime.range': '请选择日期范围',
	'app.wecom.group.search.status': '群组状态',
	'app.wecom.group.search.status.placeholder': '请选择',

	// 状态枚举
	'app.wecom.group.status.active': '在用',
	'app.wecom.group.status.archived': '已归档',
	'app.wecom.group.status.dissolved': '已解散',

	// 表格列
	'app.wecom.group.table.name': '当前页客户群',
	'app.wecom.group.table.tags': '群标签',
	'app.wecom.group.table.owner': '群主',
	'app.wecom.group.table.memberCount': '群人数',
	'app.wecom.group.table.createTime': '创建时间',

	// 操作按钮(群聊无需操作列 —— 直接点群名进详情)
	// 'app.wecom.group.button.detail': '详情',
	// 'app.wecom.group.button.sync': '同步',

	// 详情 Modal(头部 + 信息行 + 群公告 + Tabs)
	'app.wecom.group.detail.title': '客户群详情',
	'app.wecom.group.detail.owner': '群主',
	'app.wecom.group.detail.createTime': '创建时间',
	'app.wecom.group.detail.tags': '群标签',
	'app.wecom.group.detail.description': '描述',
	'app.wecom.group.detail.announcement': '群公告',
	'app.wecom.group.detail.announcement.empty': '暂无群公告',

	// 详情 Tabs
	'app.wecom.group.detail.tab.activity': '群动态',
	'app.wecom.group.detail.tab.members': '成员列表',
	'app.wecom.group.detail.tab.archive': '会话存档',

	// 详情 Tab —— 成员列表
	'app.wecom.group.detail.member.name': '当前页成员',
	'app.wecom.group.detail.member.remark': '备注',
	'app.wecom.group.detail.member.joinTime': '进群时间',
	'app.wecom.group.detail.member.joinWay': '进群方式',
	'app.wecom.group.detail.member.joinWay.invite': '由成员邀请入群',
	'app.wecom.group.detail.member.joinWay.scan': '扫码加入',
	'app.wecom.group.detail.member.joinWay.direct': '直接邀请入群',
	'app.wecom.group.detail.member.internalTag': '内部成员',
	'app.wecom.group.detail.member.batchRemark': '批量备注',
	'app.wecom.group.detail.member.empty': '暂无群成员',

	// 详情 Tab —— 会话存档
	'app.wecom.group.detail.archive.empty': '没有更多数据',

	// 空态
	'app.wecom.group.empty': '暂无客户群,试试调整筛选条件或同步企微客户群信息',

	// ===== 客户页 =====

	// 搜索区(4 个一行,7 字段)
	'app.wecom.customer.search.name': '客户名称',
	'app.wecom.customer.search.name.placeholder': '输入昵称、备注名搜索',
	'app.wecom.customer.search.source': '来源',
	'app.wecom.customer.search.source.placeholder': '请选择',
	'app.wecom.customer.search.linkedCrm': '已关联CRM',
	'app.wecom.customer.search.linkedCrm.placeholder': '请选择',
	'app.wecom.customer.search.linkedCrm.yes': '是',
	'app.wecom.customer.search.linkedCrm.no': '否',
	'app.wecom.customer.search.linkedCrm.all': '不限',
	'app.wecom.customer.search.tags': '企微标签',
	'app.wecom.customer.search.tags.placeholder': '请选择',
	'app.wecom.customer.search.adder': '添加人',
	'app.wecom.customer.search.adder.placeholder': '请选择',
	'app.wecom.customer.search.hasPhone': '备注电话',
	'app.wecom.customer.search.hasPhone.placeholder': '请选择',
	'app.wecom.customer.search.hasPhone.yes': '是',
	'app.wecom.customer.search.hasPhone.no': '否',
	'app.wecom.customer.search.hasPhone.all': '不限',
	'app.wecom.customer.search.addTime': '添加时间',
	'app.wecom.customer.search.addTime.range': '请选择日期范围',

	// 来源枚举
	'app.wecom.customer.source.wechat_add': '微信添加',
	'app.wecom.customer.source.phone_search': '手机号搜索',
	'app.wecom.customer.source.group_add': '群聊添加',
	'app.wecom.customer.source.active_code': '活码添加',
	'app.wecom.customer.source.manual_add': '手动添加',

	// 表格列
	'app.wecom.customer.table.name': '当前页客户',
	'app.wecom.customer.table.tags': '企微标签',
	'app.wecom.customer.table.corpName': '企业名称',
	'app.wecom.customer.table.adder': '添加人',
	'app.wecom.customer.table.linkedCrm': '已关联CRM',
	'app.wecom.customer.table.addTime': '添加时间',

	// 操作按钮(客户无需操作列 —— 直接点名称进详情)
	// 'app.wecom.customer.button.detail': '详情',

	// 详情 Modal
	'app.wecom.customer.detail.title': '客户详情',
	'app.wecom.customer.detail.wechatTag': '@微信',
	'app.wecom.customer.detail.nickname': '昵称',
	'app.wecom.customer.detail.remark': '备注名',
	'app.wecom.customer.detail.tags': '标签',
	'app.wecom.customer.detail.leadId': '线索编号',
	'app.wecom.customer.detail.leadOwner': '线索跟进人',

	// 详情 —— 动态 Tab
	'app.wecom.customer.detail.tab.activity': '动态',
	'app.wecom.customer.detail.tab.archive': '会话存档',
	'app.wecom.customer.detail.activity.filter.all': '全部',
	'app.wecom.customer.detail.activity.empty': '暂无更多数据',
	'app.wecom.customer.detail.activity.type.add': '好友关系',
	'app.wecom.customer.detail.activity.type.change_remark': '修改备注',
	'app.wecom.customer.detail.activity.type.add_tag': '添加标签',
	'app.wecom.customer.detail.activity.type.remove_tag': '移除标签',
	'app.wecom.customer.detail.activity.type.link_crm': '关联 CRM',

	// 详情 —— 会话存档
	'app.wecom.customer.detail.archive.colleagueList': '与客户聊过天的同事',
	'app.wecom.customer.detail.archive.colleague.empty': '暂无同事',
	'app.wecom.customer.detail.archive.message.empty': '暂无聊天记录',

	// 空态
	'app.wecom.customer.empty': '暂无客户,试试调整筛选条件或同步企微客户信息'
}
